// src/services/fiscal/MDFeService.js
import { deleteData, fetchBlobData, fetchData, postData, putData } from '../Api';

const cleanParams = (params = {}) => Object.fromEntries(
  Object.entries(params).filter(([, value]) => value !== '' && value !== null && value !== undefined),
);

export const listarMDFe = (filtros) => fetchData('/MDFe', cleanParams({
  ...filtros,
  dataInicial: filtros?.dataInicial ? `${filtros.dataInicial}T00:00:00` : '',
  dataFinal: filtros?.dataFinal ? `${filtros.dataFinal}T23:59:59` : '',
}));
export const obterMDFe = (id) => fetchData(`/MDFe/${id}`);
export const criarMDFe = (payload) => postData('/MDFe', payload);
export const atualizarMDFe = (id, payload) => putData(`/MDFe/${id}`, payload);
export const excluirMDFe = (id) => deleteData(`/MDFe/${id}`);
export const emitirMDFe = (id) => postData(`/MDFe/${id}/emitir`, {});
export const consultarMDFe = (id) => postData(`/MDFe/${id}/consultar`, {});
export const cancelarMDFe = (id, justificativa) => postData(`/MDFe/${id}/cancelar`, { justificativa });
export const encerrarMDFe = (id, payload) => postData(`/MDFe/${id}/encerrar`, payload);
export const incluirCondutorMDFe = (id, payload) => postData(`/MDFe/${id}/incluir-condutor`, payload);
export const obterNaoEncerrados = (filialId) => fetchData('/MDFe/nao-encerrados', { filialId });
export const obterStatusServico = (filialId) => fetchData('/MDFe/status-servico', { filialId });
export const baixarXmlMDFe = (id) => fetchBlobData(`/MDFe/${id}/xml`);
export const baixarDamdfe = (id) => fetchBlobData(`/MDFe/${id}/damdfe`);

export const buscarNFeAutorizadas = async (filialId) => {
  const notas = await fetchData('/Nota', { filialId, situacaoNF: 2, somenteFiscal: true });
  return (notas || []).filter((nota) => nota.modeloNF === '55' && nota.chave);
};

export const salvarBlob = (blob, nomeArquivo, abrir = false) => {
  const url = URL.createObjectURL(blob);
  if (abrir) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    const link = document.createElement('a');
    link.href = url;
    link.download = nomeArquivo;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
  window.setTimeout(() => URL.revokeObjectURL(url), abrir ? 60000 : 0);
};
